module.exports = new __parcel__URL__("image-product-4-thumbnail.c4315272.jpg").toString();